export default __webpack_public_path__ + "static/media/25.b1f3bd35.jpg";